module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Grengiols-3cbe9aa1c74f8293936702da11e1a61a.png";